import ListWithImages from "./ListWithImages";

export default ListWithImages;
